import axios from "axios";
import { getShipnowHeader } from "../../modules/common/utils/envoirenment.utils";
import { getCookieValue } from "../../modules/common/utils/cookie.utils";
import { transformRequestRes } from "../utils/requests.utils";

/**
 * Creates an Axios instance configured for the ShipNow Geocoder service.
 * Uses a base URL from environment variables and includes necessary headers.
 */
const axiosGeocoderClient = axios.create({
  baseURL: process.env.REACT_APP_SHIPNOW_GEOCODER_URL,
  headers: {
    Accept: "application/json",
    "cache-control": "no-cache",
    "Content-Type": "application/json",
    pragma: "no-cache",
    "X-Shipnow-App": getShipnowHeader(),
  },
});

/**
 * Sends a POST request to the specified Geocoder API endpoint with the provided data.
 * The request includes an authorization token retrieved from cookies.
 *
 * @param {string} url - The endpoint URL to send the request to.
 * @param {Object} data - The data to be sent in the request body.
 * @returns {Promise<Object>} A promise containing the transformed response data.
 */
export const postGeocoder = (url, data) => {
  const token = getCookieValue("sn_loggin_user_token");

  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axiosGeocoderClient
    .post(url, data, options)
    .then((res) => transformRequestRes(res));
};
